// 组件
import page from '@/common/layout/page'

import { redirectPlugin } from './plugins/redirect'
import { ossImageFilter, ossHttpVersionFilter } from './filters/oss_image'
import '@/common/widget/mask/modal'
import '@/common/widget/Slide'
import { backPlugin } from './plugins/back'
import { catchPlugin } from './plugins/catch'
// import NavBar from '@mc/maple/lib/nav-bar'
// vant引入，后续逐步替换掉maple
import {
  NoticeBar,
  Icon as VIcon,
  Button as VButton,
  Calendar,
  Area,
  Dialog,
  Field,
  Search,
  Tab,
  Tabs,
  Picker,
  Cascader,
  Popup,
  Loading,
  Toast,
  Image as VanImage,
  Lazyload,
  NavBar as VNavBar
} from 'vant'

import hevueImgPreview from 'hevue-img-preview'
import { getAppInfo } from '@/defines/environment/getters/get_app_info'
import IconFont from '@/common/widgets/iconfont'
import MapleIcon from '@/common/widget/MapleIcon'
import MapleNavBar from '@/common/widget/MapleNavBar'
import waterfall from 'vue-waterfall2'
import domMove from './directives/DomMove'
import vuePan from './directives/Pan'
import vueLoading from './widget/loading'

export const globalRegister = Vue => {
  Vue.component('Page', page)
  Vue.component('IconFont', IconFont)
  Vue.use(waterfall)
  Vue.use(vueLoading)
  Vue.component('MapleIcon', MapleIcon)
  Vue.component('MapleNavBar', MapleNavBar)

  Vue.use(redirectPlugin)
  Vue.use(backPlugin)
  Vue.use(catchPlugin)
  // Vue.use(NavBar)

  // vant引入，后续逐步替换掉maple
  Vue.use(NoticeBar)
  Vue.use(VIcon)
  Vue.use(VButton)
  Vue.use(Calendar)
  Vue.use(Area)
  Vue.use(Dialog)
  Vue.use(Field)
  Vue.use(Search)
  Vue.use(Tab)
  Vue.use(Tabs)
  Vue.use(Picker)
  Vue.use(Cascader)
  Vue.use(Popup)
  Vue.use(Loading)
  Vue.use(Toast)
  Vue.use(VanImage)
  Vue.use(Lazyload)
  Vue.use(VNavBar)

  // 指令
  Vue.use(domMove)
  Vue.use(vuePan)

  Vue.use(hevueImgPreview)

  Vue.mixin({
    computed: {
      statusBarHeight() {
        try {
          const statusBarHeight = getAppInfo().statusBarHeight
          if (statusBarHeight) {
            return Number(statusBarHeight)
          } else {
            return 0
          }
        } catch (e) {
          return 0
        }
      },
      safeBottomMargin() {
        try {
          const safeBottomMargin = getAppInfo().safeBottomMargin
          if (safeBottomMargin) {
            return Number(safeBottomMargin)
          } else {
            return 0
          }
        } catch (e) {
          return 0
        }
      }
    }
  })
  Vue.filter('ossImage', ossImageFilter)
  Vue.filter('ossHttpVersion', ossHttpVersionFilter)
}
